import React, {Fragment, FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {IconButton} from "@App/Components/common/IconButton/IconButton";
import {CarTypeIcon, CommercialVehicleTypeIcon} from "@App/Components/common/Icons";

type VehicleTypeStepProps = {
    selectCommercialVehicle: any,
};

export const VehicleTypeStep: FunctionComponent<VehicleTypeStepProps> = (props: VehicleTypeStepProps)  => {

    const {t} = useTranslation()


    return (
        <Fragment>
            <div className="overflow-hidden">
                <div
                    className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}>
                    <IconButton
                        title={t('PKW')}
                        onClick={() => props.selectCommercialVehicle(false)}
                        icon={<CarTypeIcon/>}/>
                    <IconButton
                        title={t('Nutzfahrzeug')}
                        onClick={() => props.selectCommercialVehicle(true)}
                        icon={<CommercialVehicleTypeIcon/>}/>
                </div>
            </div>
        </Fragment>
    )
}
